// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReactModal__Overlay {
    align-items: flex-end;
  }
  
  .ReactModal__Content {
    background: #ffffff;
    border: none !important;
    width: 1096px !important;
    height: 752px !important;
  
    opacity: 0;
    transform: translateY(300px);
    transition: all 300ms ease-in-out;
  }
  
  .ReactModal__Content--after-open {
    opacity: 1;
    transform: translateY(0px);
  }
  
  .ReactModal__Content--before-close {
    opacity: 0;
    transform: translateY(300px);
  }
  
  .MiddleModal__Content {
    min-width: 366px;
    max-width: 750px;
    height: 282px;
    background: #ffffff !important;
    border-radius: 20px;
    padding: 16px;
    outline: none;
    position: relative;
  
    -webkit-tap-highlight-color: transparent;
  }
  
  .MiddleModal__Overlay {
    position: fixed;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #00000060;
    z-index: 9999 !important;
  
    transition: opacity 300ms;
  }
  
  .MiddleModal__Content--before-close {
    opacity: 0;
    transition: opacity 300ms;
  }
  

.ScenarioModal__Content {
  border-radius: .75rem;
}`, "",{"version":3,"sources":["webpack://./src/components/Modal.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,wBAAwB;;IAExB,UAAU;IACV,4BAA4B;IAC5B,iCAAiC;EACnC;;EAEA;IACE,UAAU;IACV,0BAA0B;EAC5B;;EAEA;IACE,UAAU;IACV,4BAA4B;EAC9B;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,kBAAkB;;IAElB,wCAAwC;EAC1C;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,wBAAwB;;IAExB,yBAAyB;EAC3B;;EAEA;IACE,UAAU;IACV,yBAAyB;EAC3B;;;AAGF;EACE,qBAAqB;AACvB","sourcesContent":[".ReactModal__Overlay {\n    align-items: flex-end;\n  }\n  \n  .ReactModal__Content {\n    background: #ffffff;\n    border: none !important;\n    width: 1096px !important;\n    height: 752px !important;\n  \n    opacity: 0;\n    transform: translateY(300px);\n    transition: all 300ms ease-in-out;\n  }\n  \n  .ReactModal__Content--after-open {\n    opacity: 1;\n    transform: translateY(0px);\n  }\n  \n  .ReactModal__Content--before-close {\n    opacity: 0;\n    transform: translateY(300px);\n  }\n  \n  .MiddleModal__Content {\n    min-width: 366px;\n    max-width: 750px;\n    height: 282px;\n    background: #ffffff !important;\n    border-radius: 20px;\n    padding: 16px;\n    outline: none;\n    position: relative;\n  \n    -webkit-tap-highlight-color: transparent;\n  }\n  \n  .MiddleModal__Overlay {\n    position: fixed;\n    inset: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #00000060;\n    z-index: 9999 !important;\n  \n    transition: opacity 300ms;\n  }\n  \n  .MiddleModal__Content--before-close {\n    opacity: 0;\n    transition: opacity 300ms;\n  }\n  \n\n.ScenarioModal__Content {\n  border-radius: .75rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
